import React from 'react';
import './SlotButton.css';

/** Orario libero: chip salvia compatto (non ellissi a tutta riga). */
export function SlotButton({
  time,
  selected = false,
  disabled = false,
  onClick,
  className = '',
  ghost = false,
}) {
  return (
    <button
      type="button"
      className={[
        'vc-slot-btn',
        selected ? 'vc-slot-btn--selected' : '',
        ghost ? 'vc-slot-btn--ghost' : '',
        disabled ? 'vc-slot-btn--disabled' : '',
        className,
      ].filter(Boolean).join(' ')}
      aria-pressed={selected}
      disabled={disabled}
      onClick={onClick}
    >
      {time}
    </button>
  );
}

export default SlotButton;
